import React from 'react';
import { useDataValue } from 'globals/contexts/dataContext';

import './aboutMain.css';
import './aboutMainMobile.css';
const AboutMain = ({content: pageContent}) => {
  const [{content, currentLanguage}, dispatch] = useDataValue();
  return <section className="main" id="main">
    <div className="backgroundLayer" />
    <div className={`title${currentLanguage === 'zh'? ' mobile': ''}`} dangerouslySetInnerHTML={{
      __html: pageContent['title']
    }} />
    <div className={`title2${currentLanguage === 'en'? ' mobile': ''}`} dangerouslySetInnerHTML={{
      __html: pageContent['title2']
    }} />
    <div className="photo">
      <img src={pageContent['image']} />
    </div>
    <div className="content">
      {pageContent['content']}
    </div>
    <div className="info">
      <div className="label" dangerouslySetInnerHTML={{
        __html: pageContent['label']
      }} />
      <div className="line" />
      <div className="value">{pageContent['year']}<div className="unit">{pageContent['unit']}</div></div>
    </div>
    <div className="points">
      {pageContent['points'].map((point, idx) => {
        return <div className="point" key={idx}>
          <div className="stroke">
            <img src={point['image']} />
          </div>
          <div className="brief">
            {point['brief']}
          </div>
        </div>;
      })}
    </div>
</section>
}

export default AboutMain;